import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-wrapper footer-layout1 bg-dark">
      <div className="">
        <div className="container">
          <div className="newsletter-area">
            <div className="newsletter-top">
              <div className="row gy-4 align-items-center">
                

              </div>
            </div>
          </div>
          <div className="row justify-content-between">

            <div className="col-md-3 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Services We Provides</h3>
                <div className="menu-all-pages-container colorr">
<Link className="colorr" to="/Cab-Service-in-Mumbai"><i className="darkcolor"></i> Cab Service in Mumbai</Link>
<Link className="colorr" to="/Cab-Service-in-Navi-Mumbai"><i className="darkcolor"></i> Cab Service in Navi Mumbai</Link>
<Link className="colorr" to="/Cab-Service-in-Thane"><i className="darkcolor"></i> Cab Service in Thane</Link>
<Link className="colorr" to="/Cab-Service-Near-Me-Mumbai"><i className="darkcolor"></i> Cab Service Near Me Mumbai</Link>
<Link className="colorr" to="/Car-Rental-in-Mumbai"><i className="darkcolor"></i> Car Rental in Mumbai</Link>
<Link className="colorr" to="/Corporate-Cab-Services-in-Mumbai"><i className="darkcolor"></i> Corporate Cab Services in Mumbai</Link>
<Link className="colorr" to="/Online-Taxi-Booking-Mumbai"><i className="darkcolor"></i> Online Taxi Booking Mumbai</Link>
<Link className="colorr" to="/Wedding-Car-Rental-Mumbai"><i className="darkcolor"></i> Wedding Car Rental Mumbai</Link>
<Link className="colorr" to="/Tempo-Traveller-on-Rent-in-Mumbai"><i className="darkcolor"></i> Tempo Traveller on Rent in Mumbai</Link>
<Link className="colorr" to="/Innova-Crysta-on-Rent-in-Mumbai"><i className="darkcolor"></i> Innova Crysta on Rent in Mumbai</Link>
<Link className="colorr" to="/Ertiga-on-Rent-in-Mumbai"><i className="darkcolor"></i> Ertiga on Rent in Mumbai</Link>
<Link className="colorr" to="/Mini-Bus-on-Rent-in-Mumbai"><i className="darkcolor"></i> Mini Bus on Rent in Mumbai</Link>
<Link className="colorr" to="/Mumbai-Airport-Cab-Booking"><i className="darkcolor"></i> Mumbai Airport Cab Booking</Link>
<Link className="colorr" to="/Navi-Mumbai-Car-Rental-Service"><i className="darkcolor"></i> Navi Mumbai Car Rental Service</Link>
<Link className="colorr" to="/Mumbai-Airport-to-Pune-Cab"><i className="darkcolor"></i> Mumbai Airport to Pune Cab</Link>
<Link className="colorr" to="/Mumbai-Airport-to-Shirdi-Taxi"><i className="darkcolor"></i> Mumbai Airport to Shirdi Taxi</Link>
<Link className="colorr" to="/Pune-to-Mumbai-Airport-Cab"><i className="darkcolor"></i> Pune to Mumbai Airport Cab</Link>
<Link className="colorr" to="/Pune-Airport-to-Mumbai-Cab"><i className="darkcolor"></i> Pune Airport to Mumbai Cab</Link>
<Link className="colorr" to="/Surat-to-Mumbai-Airport-Taxi"><i className="darkcolor"></i> Surat to Mumbai Airport Taxi</Link>
<Link className="colorr" to="/Nashik-to-Mumbai-Airport-Cab"><i className="darkcolor"></i> Nashik to Mumbai Airport Cab</Link>
<Link className="colorr" to="/Mumbai-to-Nashik-Cab"><i className="darkcolor"></i> Mumbai to Nashik Cab</Link>
<Link className="colorr" to="/Mumbai-to-Shirdi-Cab"><i className="darkcolor"></i> Mumbai to Shirdi Cab</Link>
<Link className="colorr" to="/Mumbai-to-Lonavala-Cab"><i className="darkcolor"></i> Mumbai to Lonavala Cab</Link>
<Link className="colorr" to="/Mumbai-to-Khandala-Cab"><i className="darkcolor"></i> Mumbai to Khandala Cab</Link>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Services We Provides</h3>
                <div className="menu-all-pages-container colorr">

<Link className="colorr" to="/Mumbai-to-Matheran-Cab"><i className="darkcolor"></i> Mumbai to Matheran Cab</Link>
<Link className="colorr" to="/Mumbai-to-Kolhapur-Cab"><i className="darkcolor"></i> Mumbai to Kolhapur Cab</Link>
<Link className="colorr" to="/Mumbai-to-Mahabaleshwar-Cab"><i className="darkcolor"></i> Mumbai to Mahabaleshwar Cab</Link>
<Link className="colorr" to="/Mumbai-to-Panchgani-Cab"><i className="darkcolor"></i> Mumbai to Panchgani Cab</Link>
<Link className="colorr" to="/Mumbai-to-Pandharpur-Cab"><i className="darkcolor"></i> Mumbai to Pandharpur Cab</Link>
<Link className="colorr" to="/Mumbai-to-Ashtavinayak-Cab-Service"><i className="darkcolor"></i> Mumbai to Ashtavinayak Cab Service</Link>
<Link className="colorr" to="/Mumbai-to-5-Jyotirlinga-Cab"><i className="darkcolor"></i> Mumbai to 5 Jyotirlinga Cab</Link>
<Link className="colorr" to="/Mumbai-to-Bhimashankar-Cab"><i className="darkcolor"></i> Mumbai to Bhimashankar Cab</Link>
<Link className="colorr" to="/Mumbai-to-Goa-Cab"><i className="darkcolor"></i> Mumbai to Goa Cab</Link>
<Link className="colorr" to="/Mumbai-to-Alibaug-Cab"><i className="darkcolor"></i> Mumbai to Alibaug Cab</Link>
<Link className="colorr" to="/Mumbai-to-Imagica-Cab"><i className="darkcolor"></i> Mumbai to Imagica Cab</Link>
<Link className="colorr" to="/Mumbai-to-Indore-Cab"><i className="darkcolor"></i> Mumbai to Indore Cab</Link>
<Link className="colorr" to="/Mumbai-to-Jaipur-Cab"><i className="darkcolor"></i> Mumbai to Jaipur Cab</Link>
<Link className="colorr" to="/Mumbai-to-Jalgaon-Cab"><i className="darkcolor"></i> Mumbai to Jalgaon Cab</Link>
<Link className="colorr" to="/Mumbai-to-Dhule-Cab"><i className="darkcolor"></i> Mumbai to Dhule Cab</Link>
<Link className="colorr" to="/Mumbai-to-Satara-Cab"><i className="darkcolor"></i> Mumbai to Satara Cab</Link>
<Link className="colorr" to="/Mumbai-to-Surat-Cab"><i className="darkcolor"></i> Mumbai to Surat Cab</Link>
<Link className="colorr" to="/Mumbai-to-Vadodara-Cab"><i className="darkcolor"></i> Mumbai to Vadodara Cab</Link>
<Link className="colorr" to="/Mumbai-to-Ahmedabad-Cab"><i className="darkcolor"></i> Mumbai to Ahmedabad Cab</Link>
<Link className="colorr" to="/Mumbai-to-Konkan-Darshan-Cab"><i className="darkcolor"></i> Mumbai to Konkan Darshan Cab</Link>
<Link className="colorr" to="/Mumbai-to-Ganpatipule-Cab"><i className="darkcolor"></i> Mumbai to Ganpatipule Cab</Link>
<Link className="colorr" to="/Mumbai-to-Tarkarli-Cab"><i className="darkcolor"></i> Mumbai to Tarkarli Cab</Link>
<Link className="colorr" to="/Mumbai-to-Malvan-Cab"><i className="darkcolor"></i> Mumbai to Malvan Cab</Link>
<Link className="colorr" to="/Mumbai-to-Raigad-Cab"><i className="darkcolor"></i> Mumbai to Raigad Cab</Link>
<Link className="colorr" to="/Pune-to-Mumbai-Cab"><i className="darkcolor"></i> Pune to Mumbai Cab</Link>
                
                </div>
              </div>
            </div>


            <div className="col-md-3 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title text-white">Services We Provides</h3>
                <div className="menu-all-pages-container colorr">

<Link className="colorr" to="/Nashik-to-Mumbai-Cab"><i className="darkcolor"></i> Nashik to Mumbai Cab</Link>
<Link className="colorr" to="/Kolhapur-to-Mumbai-Cab"><i className="darkcolor"></i> Kolhapur to Mumbai Cab</Link>
<Link className="colorr" to="/Ahmedabad-to-Mumbai-Cab"><i className="darkcolor"></i> Ahmedabad to Mumbai Cab</Link>
<Link className="colorr" to="/Surat-to-Mumbai-Cab"><i className="darkcolor"></i> Surat to Mumbai Cab</Link>
<Link className="colorr" to="/Mahabaleshwar-to-Mumbai-Cab"><i className="darkcolor"></i> Mahabaleshwar to Mumbai Cab</Link>
<Link className="colorr" to="/Panchgani-to-Mumbai-Cab"><i className="darkcolor"></i> Panchgani to Mumbai Cab</Link>
<Link className="colorr" to="/Goa-to-Mumbai-Cab"><i className="darkcolor"></i> Goa to Mumbai Cab</Link>
<Link className="colorr" to="/Mumbai-to-Konkan-Cab"><i className="darkcolor"></i> Mumbai to Konkan Cab</Link>
<Link className="colorr" to="/Mumbai-to-Aurangabad-Cab"><i className="darkcolor"></i> Mumbai to Aurangabad Cab</Link>
<Link className="colorr" to="/Mumbai-to-Akkalkot-cab-fare"><i className="darkcolor"></i> Mumbai to Akkalkot cab fare</Link>
<Link className="colorr" to="/Mumbai-to-Tuljapur-Car-Rental"><i className="darkcolor"></i> Mumbai to Tuljapur Car Rental</Link>
<Link className="colorr" to="/Mumbai-to-Bangalore-cab"><i className="darkcolor"></i> Mumbai to Bangalore cab</Link>
<Link className="colorr" to="/Mumbai-to-Daman-taxi"><i className="darkcolor"></i> Mumbai to Daman taxi</Link>
<Link className="colorr" to="/Mumbai-to-Khandala-Taxi-Fare"><i className="darkcolor"></i> Mumbai to Khandala Taxi Fare</Link>
<Link className="colorr" to="/Mumbai-to-Vapi-Cab"><i className="darkcolor"></i> Mumbai to Vapi Cab</Link>
<Link className="colorr" to="/Toyota-Etios-on-Rent-in-Mumbai"><i className="darkcolor"></i> Toyota Etios on Rent in Mumbai</Link>
<Link className="colorr" to="/Taxi-Service-at-Mumbai-International-Airport"><i className="darkcolor"></i> Taxi Service at Mumbai International Airport</Link>
<Link className="colorr" to="/Swift-Dzire-on-Rent-in-Mumbai"><i className="darkcolor"></i> Swift Dzire on Rent in Mumbai</Link>
<Link className="colorr" to="/Sedan-Cab-Service-Mumbai"><i className="darkcolor"></i> Sedan Cab Service Mumbai</Link>
<Link className="colorr" to="/Round-Trip-Cab-Booking-Mumbai"><i className="darkcolor"></i> Round Trip Cab Booking Mumbai</Link>
<Link className="colorr" to="/Mumbai-Outstation-Cabs"><i className="darkcolor"></i> Mumbai Outstation Cabs</Link>
<Link className="colorr" to="/Mumbai-darshan-cabs"><i className="darkcolor"></i> Mumbai darshan cabs</Link>
<Link className="colorr" to="/Best-taxi-service-in-mumbai"><i className="darkcolor"></i> Best taxi service in mumbai</Link>
<Link className="colorr" to="/Mumbai-to-Nagpur-Cab"><i className="darkcolor"></i> Mumbai to Nagpur Cab</Link>

                </div>
              </div>
            </div>

            <div className="col-md-3 col-xl-3">
              {/* <div className=""> */}
              <h3 className="">Address</h3>
              {/* <div className=""> */}
              <div className="info-box_text">
                <div className="icon">
                  <img src="/img/icon/phone.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    <a href="tel:+918108807171" className="info-box_link text-white">
                      +91 8108807171
                    </a>
                  </p>
                  <p>
                    <a href="tel:+919764227171" className="info-box_link text-white">
                      +91 9764227171
                    </a>
                  </p>
                </div>
              </div>
              <div className="info-box_text">
                <div className="icon">
                  <img src="/img/icon/envelope.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    <a
                      href="mailto:booking@devacab.com"
                      className="info-box_link text-white"
                    >
                      booking@devacab.com
                    </a>
                  </p>

                </div>
              </div>
              <div className="info-box_text">
                <div className="icon">
                  <img src="/img/icon/location-dot.svg" alt="img" />
                </div>
                <div className="details">
                  <p className='text-white'>SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709</p>
                </div>
              </div>

              {/* <div className="container-fluid"> */}
              <div className="">


      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2979.778825552838!2d72.99910315!3d19.10186327!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c1d470c80bed%3A0x48f0b6e70d65c241!2sAtharvashirsh!5e1!3m2!1sen!2sin!4v1752753866890!5m2!1sen!2sin"  width="auto"
  height="auto" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


              </div>
              {/* </div> */}

            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      <div className="copyright-wrap" data-bg-src="/img/bg/copyright_bg_1.jpg">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-12 text-center">

              <p className="copyright-text">
                All Rights Reserved &copy;  <span className="darkcolorr">Deva Cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolorr">&nbsp;Dexter Intelligence</span>
                </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                  <span className="darkcolorr">&nbsp;Urva Hosting</span>
                </a>
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
